import { deleteResource, getResource, putResource } from './index';
import { Constants } from '../constants';
import { UserAttributeType} from '../types/auth_types';
import {RatingFormAttributeType} from '../types/util_types';

export const getBookingList = async (
  user: UserAttributeType,
  currentBusinessId: string,
  pageNumber = 1,
  q = '',
  status = '',
  from = '',
  to = '',
  fetchAll = false
) => {
  return await getResource(
    `/v1/businesses/${currentBusinessId}/bookings?page=${pageNumber}&per_page=${Constants.PerPageCount.Bookings}&q=${q}&from=${from}&to=${to}&status=${status}&fetch_all=${fetchAll}`,
    user.token
  );
};

export const findBooking = async (user: UserAttributeType, currentBusinessId: string, id: number) => {
  return await getResource(
    `/v1/businesses/${currentBusinessId}/bookings/${id}`,
    user.token
  );
};

export const customerRating = async (user: UserAttributeType, id: number, {
  note,
  score
}: RatingFormAttributeType) => {
  return await putResource(
    `/v1/ratings/${id}`,
    {
      rating: {
        customer_note: note,
        customer_score: score
      }
    },
    user.token
  );
};

export const bookingCancellation = async (
  user: UserAttributeType,
  currentBusinessId: string,
  id: number,
  cancellation_note: string
) => {
  return await deleteResource(
    `/v1/businesses/${currentBusinessId}/bookings/${id}`,
    {cancellation_note: cancellation_note},
    user.token
  );
};
